import { Col, Row } from 'antd';
import { withNamespaces } from 'react-i18next';
import { useSelector } from 'react-redux';

import GroupPeriodLookupSelect from '../../components/GroupPeriodLookupSelect';
import HorizontalLineDivider from '../../components/HorizontalLineDivider';
import UserGroupsLookupSelect from '../../components/UserGroupsLookupSelect';
import PageContainer from '../../containers/PageContainer';
import withAuthentication from '../../hocs/withAuthentication';
import {
  hasCompanyAdminRole,
  hasCompanyManagerOrAdminRole,
  hasCompanyManagerRole,
  hasUserRole,
} from '../../utils/roles';
import CardsRowSection from './Cards/CardsRowSection';
import ComplianceWatch from './ComplianceWatch';
import useDashboardEventTimelineState from './DashboardEventTimeline/useDashboardEventTimelineState';
import DashboardScheduleTimeline from './DashboardScheduleTimeline';
import ManagerBlurredContent from './ManagerBlurredContent';
import classNames from './style.module.scss';
import useDashboardState from './useDashboardState';
const DashboardPage = props => {
  const { t } = props;

  const currentCompany = useSelector(store => store.common.currentCompany);
  const groupList = useSelector(store => (store.group ? store.group.groupList : []));
  const myProfile = useSelector(store => store.profile);
  const companySettings = useSelector(store => store.common.currentCompany.companySettingId);

  const {
    timeline,
    isLoading: isLoadingTimeline,
    timelineFilters,
    handleTimelineFilters,
    handleGroupChange,
  } = useDashboardEventTimelineState();

  const { dashboardDataQuery } = useDashboardState({
    myProfile,
    timelineFilters,
  });

  const hasNonAdHocPaymentSchedules =
    timelineFilters?.groupID && !timelineFilters?.startDate && !timelineFilters?.endDate;

  const showReimbursementPipeline =
    hasCompanyManagerOrAdminRole(myProfile) &&
    !!timelineFilters?.startDate &&
    !!timelineFilters?.endDate;

  const SECION_HEADER = (
    <Row
      gutter={[16, 16]}
      justify="space-between"
      style={{
        display: hasCompanyManagerOrAdminRole(myProfile) ? 'flex' : 'none',
      }}
    >
      <Col flex="600px">
        <Row gutter={16}>
          <Col flex="300px">
            <UserGroupsLookupSelect
              t={t}
              allowClear={false}
              userId={myProfile?.profile?._id}
              value={timelineFilters.groupID}
              onChange={groupID => {
                handleGroupChange(groupID);
              }}
            />
          </Col>

          <Col flex="250px">
            <GroupPeriodLookupSelect
              t={t}
              hideOnEmpty
              groupId={timelineFilters.groupID}
              allowClear={false}
              value={
                timelineFilters.startDate && timelineFilters.endDate
                  ? JSON.stringify({
                      fromDate: timelineFilters.startDate,
                      endDate: timelineFilters.endDate,
                    })
                  : null
              }
              onChange={period => {
                const parsedPeriod = JSON.parse(period);
                handleTimelineFilters({
                  groupID: timelineFilters.groupID,
                  startDate: parsedPeriod.fromDate,
                  endDate: parsedPeriod.endDate,
                });
              }}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );

  return (
    <PageContainer title={t('Dashboard')} className={classNames.dashboardPage}>
      {SECION_HEADER}

      <CardsRowSection
        t={t}
        user={myProfile}
        isLoading={!dashboardDataQuery.isFetched || dashboardDataQuery.isFetching}
        data={dashboardDataQuery.data}
        companySettings={companySettings}
        timelineFilters={timelineFilters}
        showReimbursementPipeline={showReimbursementPipeline}
      />

      <Row style={{ marginBottom: 30 }}>
        <Col flex={1}>
          <DashboardScheduleTimeline
            t={t}
            user={myProfile}
            selectedGroupId={
              hasUserRole(myProfile) ? myProfile?.profile?.group?._id : timelineFilters?.groupID
            }
            timelineFilters={timelineFilters}
            timeline={timeline}
            isTimelineLoading={isLoadingTimeline}
            dashboardData={dashboardDataQuery.data}
            onPeriodChange={handleTimelineFilters}
          />
        </Col>
      </Row>

      <HorizontalLineDivider
        marginTop={
          hasCompanyManagerOrAdminRole(myProfile) && hasNonAdHocPaymentSchedules ? '0px' : '30px'
        }
        marginBottom="30px"
      />

      {hasCompanyManagerRole(myProfile) && !timelineFilters?.groupID && (
        <ManagerBlurredContent t={t} />
      )}

      {hasCompanyAdminRole(myProfile) && (
        <Row style={{ marginBottom: 30 }}>
          <Col flex={1}>
            <ComplianceWatch currentCompany={currentCompany} groupList={groupList} />
          </Col>
        </Row>
      )}
    </PageContainer>
  );
};

export default withNamespaces()(withAuthentication(DashboardPage));
